import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskLines, Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, image, pos, testid = "page-hero" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  return (
    <section ref={ref} data-testid={testid} className="relative bg-ink text-white overflow-hidden grain">
      <div className="absolute inset-0 blueprint" />
      <div className="container-x relative pt-36 sm:pt-44 pb-16 sm:pb-24 grid gap-12 lg:grid-cols-12 items-end">
        <div className="lg:col-span-7">
          <Reveal><p className="eyebrow text-brass mb-6">{eyebrow}</p></Reveal>
          <h1 className="font-wide font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            <MaskLines lines={lines} animateOnLoad />
          </h1>
          {intro && <Reveal delay={0.3}><p className="mt-8 text-slate-300 text-base md:text-lg max-w-xl leading-relaxed">{intro}</p></Reveal>}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/3] clip-notch overflow-hidden bg-ink2">
              <motion.img style={{ y, scale: 1.15, objectPosition: pos }} src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/25 to-transparent" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
